(function(){
'use strict';

createFbq.$inject = ["$q", "$window", "scAnalyticsUtils", "scAnalyticsServiceSettings", "scFacebookPixelService"];
function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

function createFbq($q, $window, scAnalyticsUtils, scAnalyticsServiceSettings, scFacebookPixelService) {
  var _this = this;

  var fbqService = { name: 'facebook_pixel' };
  var debugLog = scAnalyticsUtils.debugLog;

  /* Interface Methods
  ========================================================= */

  fbqService.registerSuperProperties = function () {};
  fbqService.identifyMember = function () {};
  fbqService.eventBeacon = function () {};

  var retryUntilTrueThenCall = function retryUntilTrueThenCall(checkFn, onSuccessFn) {
    var intervalMs = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 50;

    var tryCheck = function tryCheck() {
      if (checkFn()) {
        onSuccessFn();
      } else {
        setTimeout(tryCheck, intervalMs);
      }
    };
    tryCheck();
  };

  fbqService.loaded = function () {
    return $q(function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee(resolve, reject) {
        return regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (!getPixelId()) {
                  _context.next = 9;
                  break;
                }

              case 1:
                if ($window.fbq) {
                  _context.next = 6;
                  break;
                }

                _context.next = 4;
                return checkFbqStatus();

              case 4:
                _context.next = 1;
                break;

              case 6:
                return _context.abrupt('return', resolve());

              case 9:
                return _context.abrupt('return', reject());

              case 10:
              case 'end':
                return _context.stop();
            }
          }
        }, _callee, _this);
      }));

      return function (_x2, _x3) {
        return _ref.apply(this, arguments);
      };
    }());
  };

  fbqService.recordPageView = function (data) {
    return fbPageView(data);
  };

  fbqService.track = function (event, data) {
    return facebookPixel(event, data);
  };

  return fbqService;

  /* Private Methods
  ========================================================= */
  function getPixelId() {
    var campaignPixel = scAnalyticsServiceSettings.getByName('campaign', 'facebook_pixel');
    var orgPixel = scAnalyticsServiceSettings.getByName('organization', 'facebook_pixel');

    return _.get(campaignPixel, ['parameters', 'pixel_id'], _.get(orgPixel, ['parameters', 'pixel_id'], false));
  }

  function checkFbqStatus() {
    return new Promise(function (resolve) {
      return setTimeout(resolve, 50);
    }).then(function () {
      if (typeof $window.fbq !== 'undefined') {
        return true;
      } else {
        return false;
      }
    });
  }

  function hasEventOnCampaign(event) {
    var campaignPixel = scAnalyticsServiceSettings.getByName('campaign', 'facebook_pixel');

    return _.get(campaignPixel, ['tracked_events', event], false);
  }

  function hasEventOnOrganization(event) {
    var orgPixel = scAnalyticsServiceSettings.getByName('organization', 'facebook_pixel');

    return _.get(orgPixel, ['tracked_events', event], false);
  }

  function fbPageView(data) {
    var fbqCall = function fbqCall() {
      return fbq('track', 'ViewContent', {
        content_name: data.title,
        content_url: window.location.pathname + window.location.search + window.location.hash
      }, { eventID: _.get(data, 'event_id') });
    };
    retryUntilTrueThenCall(scFacebookPixelService.isPixelInitialized, fbqCall);
  }

  function facebookPixel(event, data) {
    var pixelId = getPixelId();
    if (pixelId) {
      var hasEventTurnedOn = hasEventOnCampaign(event) || hasEventOnOrganization(event);

      if (hasEventTurnedOn) {
        debugLog('facebook_pixel', data);

        var fbqCall = function fbqCall() {
          var numItems = _.get(data, 'items.length', 0) + (_.get(data, 'donation_amount', null) ? 1 : 0);
          switch (event) {
            case 'fundraising-page/create/complete':
              fbq('track', 'CompleteRegistration', {
                content_name: 'Fundraising Page Signup'
              }, { eventID: _.get(data, 'event_id') });
              break;
            case 'donation/create/begin':
              fbq('track', 'InitiateCheckout', {}, { eventID: _.get(data, 'event_id') });
              break;
            case 'donation/create/complete':
              fbq('track', 'Purchase', {
                content_name: 'Donation',
                content_category: 'one-time',
                value: _.get(data, 'amount', 0),
                currency: _.get(data, 'currency', 'USD')
              }, { eventID: _.get(data, 'event_id') });
              break;
            case 'registration/create/begin':
              fbq('track', 'AddToCart', {
                content_name: 'Registration',
                value: _.get(data, 'amount', null),
                currency: _.get(data, 'currency', 'USD'),
                items: _.get(data, 'items.length', 0)
              }, { eventID: _.get(data, 'event_id') });
              break;
            case 'registration/create/complete':
              fbq('track', 'CompleteRegistration', {
                content_name: 'Registration',
                value: _.get(data, 'amount', 0),
                currency: _.get(data, 'currency', 'USD'),
                items: numItems,
                donation_frequency: _.get(data, 'donation_frequency', '')
              }, { eventID: _.get(data, 'event_id') });
              break;
            case 'recurring-donation/create/complete':
              fbq('track', 'Purchase', {
                content_name: 'Donation',
                content_category: 'recurring',
                value: _.get(data, 'amount', 0),
                currency: _.get(data, 'currency', 'USD')
              }, { eventID: _.get(data, 'event_id') });
              break;
            default:
              break;
          }
        };
        retryUntilTrueThenCall(scFacebookPixelService.isPixelInitialized, fbqCall);
      }
    }
  }
}

angular.module('classy').factory('fbqService', createFbq);
})();